import { render, staticRenderFns } from "./AdminLogList.vue?vue&type=template&id=dcdb39a6"
import script from "./AdminLogList.vue?vue&type=script&lang=js"
export * from "./AdminLogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports